import {useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PerfilTarea from "./perfilTarea/PerfilTarea";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import BranchAuthorizeIcon from '@rsuite/icons/BranchAuthorize';
import ListIcon from '@rsuite/icons/List';
import 'rsuite/Badge/styles/index.css';
import VistaLista from "./vistas/VistaLista";
import VistaArbol from "./vistas/VistaArbol";
import { useToast } from "../../components/notificaciones/ToastProvider";
import ToastNotificacion from "../../components/notificaciones/ToastNotificacion";
import {axiosInstance} from "../../components/helpers/axiosInstance";
import logo from '../../assets/media/logos/fiducia/fd-isotipo-color.svg';

export default function Todo() {

    const [task, setTask] = useState([]);
    const [idTask, setIdTask] = useState('tree');
    const toast = useToast();
    const [tabs, setTabs] = useState([]);
    const [itChange, setItChange] = useState(false);
    const [show, setShow] = useState(false);

    let params = useParams();
    useEffect(() => {
        setIdTask(params.tabId);
    }, [params.tabId]);
    /**
     * @param res.data.tareas : tareas de la base de datos
     * @param res.data.catalogos.prioridades :  prioridades para las tareas
     * @param res.data.catalogos.roles : roles para los miembros de la tarea
     */

    useEffect(() => {
        if (localStorage.getItem('catalogos')){
            axiosInstance.get('/todo/tareas/catalogos')
                .then(res => {
                    if (res.status === 200){
                        setTask(res.data.tareas);
                    }
                })
                .catch( error => console.error(error));
        } else {
            axiosInstance.get('/todo/tareas/catalogos?catalogos=true')
                .then(res => {
                    if (res.status === 200){
                        localStorage.setItem("prioridades", JSON.stringify(res.data.catalogos.prioridades));
                        localStorage.setItem('roles', JSON.stringify(res.data.catalogos.roles));
                        localStorage.setItem('catalogos', 'true');
                        setTask(res.data.tareas)
                    }
                })
                .catch( error => console.error(error));
        }
    }, [toast.arrayToast]);

    function deleteTab(id){
        setTabs(tabs.filter(t => t.id_tarea !== Number(id)));
        setIdTask(params.tabId);
        setShow(false);
    }

    function handleClose(id, e){
        if (itChange){
            setShow(true);
        } else {
            e.stopPropagation();
            deleteTab(id);
        }
    }
    function toggleShow(e, id, title){
        e.stopPropagation();
        const exist = tabs.some(t => t.id_tarea === id);
        setIdTask(id);
        if (!exist) {
            setTabs( prevState => [
                ...prevState, {
                    id_tarea :  id,
                    tarea : title
                }
            ])
        }
    }

    const filtroTab = () => {
        // eslint-disable-next-line
        switch (params.tabId){
            case 'tree':
                return(
                    <Tab eventKey={'tree'} title={<><BranchAuthorizeIcon/> Proyectos <span></span></>}>
                        {
                            task.length > 0 ? (
                                <VistaArbol task={task} toggleShow={toggleShow}></VistaArbol>
                            ) : (
                                <div className="position-relative flex-column" style={{height: "10rem"}}>
                                    <img alt="Logo" className="h-45px position-absolute top-50 start-50 translate-middle"
                                         src={logo}/>
                                    <div className="d-flex align-items-center mt-1 position-absolute bottom-0 start-50 translate-middle-x">
                                        <span className="spinner-border text-primary" role="status"></span>
                                        <span className="text-muted fs-6 fw-semibold ms-5">Cargando...</span>
                                    </div>
                                </div>
                            )
                        }
                    </Tab>
                );
            case 'list':
                return (
                    <Tab eventKey="list" title={<> <ListIcon/> Tareas <span></span></>}>
                        {
                            task.length > 0 ? (
                                <VistaLista options={task} toggleShow={toggleShow}></VistaLista>
                            ) : (
                                <div className="position-relative flex-column" style={{height: "10rem"}}>
                                    <img alt="Logo" className="h-45px position-absolute top-50 start-50 translate-middle"
                                         src={logo}/>
                                    <div className="d-flex align-items-center mt-1 position-absolute bottom-0 start-50 translate-middle-x">
                                        <span className="spinner-border text-primary" role="status"></span>
                                        <span className="text-muted fs-6 fw-semibold ms-5">Cargando...</span>
                                    </div>
                                </div>
                            )
                        }
                    </Tab>
                );
        }
    }

    return (
        <>
            <style type='text/css'>
                {`
                    @media (max-width: 767.98px) {
                        .nav-item .nav-link i:before {
                            margin-top: -8px!important;
                        }
                        .nav-item .nav-link span:before {
                            margin-top: -8px!important;
                        }
                    }

                    .nav-tabs-fiducia {
                        position : sticky;
                        top : 5.769230769rem;
                        z-index : 5;
                    }
                    
                    @media (max-width: 991.98px) {
                        .nav-tabs-fiducia {
                            position : sticky;
                            top : 4.615384615rem;
                            z-index : 5;
                        }
                    }
                `}
            </style>

            <ToastNotificacion></ToastNotificacion>

            <div className="content d-flex flex-column flex-column-fluid pt-0" id="kt_content_tab">
                <div id="content_container"
                     className=""> {/*style={{display: 'contents'}} renderizar primero el componente Header*/}
                    <Tabs
                        className={"nav-tabs-fiducia"}
                        defaultActiveKey = {params.tabId}
                        transition={false}
                        id="noanim-tab-example"
                        activeKey={idTask}
                        onSelect={(key, event) => {
                            event.stopPropagation();
                            setIdTask(key);
                        }}
                    >
                        {
                            filtroTab()
                        }
                        {
                            tabs && tabs.length > 0 && tabs.map((t) => {
                                return (
                                    <Tab key={t.id_tarea} eventKey={t.id_tarea} title={<> <b className={"text-truncate mw-100px d-inline-block fw-normal"}>{t.tarea}</b> <i onClick={(e) => handleClose(t.id_tarea, e)}></i></>}>
                                        <PerfilTarea idTask={idTask} toggleShow={toggleShow} setItChange={setItChange} show={show} setShow={setShow} deleteTab={deleteTab}></PerfilTarea>
                                    </Tab>
                                );
                            })
                        }
                    </Tabs>
                </div>
            </div>
        </>
    );
}
